import React, { useState } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import {
  Div, Button, Icon, Input, H3, DynamicButtonLink, Loading,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/suppliers-components'
import { SUPPLIERS } from '../../../constants/graph/query'
import { ListContainer, Select } from '../../../components/common'
import { PAYMENT_TYPE } from '../constants'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'
import config from './config'

const { color } = theme

const Index = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รายชื่อผู้จำหน่าย</H3>
      <Div display='flex' flexDirection='row' justifyContent='space-between'>
        <DynamicButtonLink link='/supplier/add' condition={_.includes(window.perms, PERMISSION.CREATE_SUPPLIER)} props={{ text: 'เพิ่มผู้จำหน่าย' }}/>
      </Div>
    </Div>
    <List/>
  </Div>
)

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [variable, setVariable] = useState({})
  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(SUPPLIERS, {
    variables: {
      ...variable,
      limit: 5,
      offset: 5 * current,
    },
  })
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      { loading && _.isEmpty(data) && <Loading center='true' />}
      { (!loading || !_.isEmpty(data))
        && <Div>
            <ReactTable
              className='table'
              data={data.supplierList.data.list} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: `3px solid ${color.primaryColor}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              page={current}
              pages={Math.ceil(data.supplierList.data.total / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {
                  name: '',
                  officeTel: '',
                  contactName: '',
                  contactPhoneNumber: '',
                }
                await newFiltered.forEach((v) => {
                  // if (v.id === 'contactAddress.contactOfficeTel') {
                  //   Object.assign(newOjb, { contactOfficeTel: v.value })
                  // } else {
                  //   Object.assign(newOjb, { [v.id]: v.value })
                  // }
                  Object.assign(newOjb, { [v.id]: v.value })
                })
                setCurrent(0)
                refetch(newOjb)
                setVariable(newOjb)
              }}
              onSortedChange={async (newSorted) => {
                setCurrent(0)
                refetch({
                  orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                  orderField: newSorted[0].id,
                })
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
        </Div>
      }
    </Wrapper>
  )
}

export default Index
